import ERRORS from 'constants/errorTypes'

export class ForbiddenError extends Error {
  constructor(user) {
    const message = `Forbidden to access admin with a role of ${user.role}`
    super(message)

    this.error = ERRORS.FORBIDDEN
  }
}

export class RateLimitExceeded extends Error {
  constructor() {
    const message = 'Rate limit exceeded'
    super(message)

    this.error = ERRORS.RATE_LIMIT
  }
}

export class NotFoundError extends Error {
  constructor() {
    const message = 'Resource not found'
    super(message)

    this.error = ERRORS.NOT_FOUND
  }
}

export class ServiceUnavailableError extends Error {
  constructor() {
    const message = 'Service temporarily unavailable'
    super(message)

    this.error = ERRORS.SERVICE_UNAVAILABLE
  }
}

export class ValidationError extends Error {
  constructor(validationErrors = []) {
    const message =
      validationErrors.length > 0
        ? validationErrors.map(err => err.message).join(', ')
        : 'Validation failed'
    super(message)

    this.error = ERRORS.VALIDATION
    this.validationErrors = validationErrors
  }
}
